import { useQuery } from 'react-query';
import { useAxios } from '../../../hooks/useAxios';
import { CONTRACT_PROVIDER_PAY } from 'src/constants/ehrFeatureFlags';
export var useInvoices = function (_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? true : _b, providerId = _a.providerId;
    var axios = useAxios();
    return useQuery(['invoices', providerId], function () { return axios.get("api/v1/providers/".concat(providerId, "/invoices")); }, {
        select: function (response) {
            var providerPayEnabled = response.headers['x-enabled-features'].includes(CONTRACT_PROVIDER_PAY);
            return { invoices: providerPayEnabled ? response.data.data : [], providerPayEnabled: providerPayEnabled };
        },
        enabled: enabled,
    });
};
